import { render, staticRenderFns } from "./StoreDisableRegistrationsForm.vue?vue&type=template&id=e6e70524&"
import script from "./StoreDisableRegistrationsForm.vue?vue&type=script&lang=js&"
export * from "./StoreDisableRegistrationsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports